export * from "-!../../../../../node_modules/babel-loader/lib/index.js!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=2efb0678"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/ConceptsValidation/index.vue?vue&type=template&id=2efb0678
// module id = 1927
// module chunks = 31